// PRD 17 §3.7 — the notification-policy screen shows two sections, 환자 알림 (patient)
// and 의료진 알림 (staff). The backend resolves each event's `audience` (FEATURE_049
// admin-api NotificationPolicyResponse), so this file is a thin, pure split off that
// field — no eventKey→section mapping lives on the FE side.

import type { NotificationPolicy } from '../types/notification-settings.types';

export function splitByAudience(events: NotificationPolicy[]): {
  patientEvents: NotificationPolicy[];
  staffEvents: NotificationPolicy[];
} {
  return {
    patientEvents: events.filter((e) => e.audience === 'PATIENT'),
    staffEvents: events.filter((e) => e.audience === 'STAFF'),
  };
}
